


















































import J03ResultScreen from "@/general/components/pages/parts/ThanksPointResultScreen/J03ResultScreen.vue";
import J03ResultScreenUser from "@/general/components/pages/parts/ThanksPointResultScreen/J03ResultScreenUser.vue";
import { Prop, Vue, Component } from "vue-property-decorator";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";
import CONST_DATA from "@/general/mixins/const/constData";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";

@Component({
  components: {
    J03ResultScreen,
    J03ResultScreenUser
  }
})
export default class ThanksPointSearchResult extends Vue {
  @Prop({ type: [], default: [] }) userSearchList!: any;
  @Prop({ type: [], default: [] }) thankPointSearchList!: any;
  @Prop({ type: String, default: "" }) keyword!: string;
  @Prop({ type: Number, default: 0}) errorCount: Number;

  searchKeyword = "";
  messagesSearchResults: any = {
    total_count: -1,
    items: []
  };
  usersSearchResults: any = {
    total_count: -1,
    items: []
  };
  currentPagedoSearch!: number;
  pageNavi: Record<string, any> = {
    currentPage: 1,
    prevPageUrl: "",
    nextPageUrl: "",
    maxPage: 0,
    baseUrl: ""
  };
  breadcrumb: any = [
    {
      text: "",
      url: SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "サンクスメッセージ",
      url: SITE_MAP.THANKS_POINT,
      pageType: "lower"
    },
    {
      text: "検索",
      url: "",
      pageType: "lower"
    }
    ];

  get moreLink() {
    return {
      user:
        "/thanks-point-search-user-more/?search=" +
        this.searchKeyword +
        "&page=2",
      message:
        "/thanks-point-search-message-more/?search=" +
        this.searchKeyword +
        "&page=2"
    };
  }
  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }

  get currentPage() {
    return this.pageNavi.currentPage;
  }
  get maxPage() {
    return this.pageNavi.maxPage;
  }

  get nextPageUrl() {
    return this.pageNavi.nextPageUrl;
  }

  get prevPageUrl() {
    return this.pageNavi.prevPageUrl;
  }

  get baseUrl() {
    return this.pageNavi.baseUrl;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  async created() {
    this.breadcrumb[1].text = this.thanksPointName + "メッセージ";
    await commons.setbreadcrumb(this.breadcrumb);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pageParam = urlParams.get("page");
    const search = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : "";
    const currentPage = pageParam ? parseInt(pageParam) : 1;
    this.pageNavi.currentPage = currentPage;
    this.searchKeyword = this.keyword || search;

    // DC_IC-942
    this.handleThanksPointSearch(this.thankPointSearchList, this.searchKeyword);
    this.handleUserSearch(this.userSearchList, this.searchKeyword);
    this.handlePager();
  }

  async handleThanksPointSearch(thanksPointList: any, search: string) {
    thanksPointList.results?.forEach((resObj: any) => {
      this.messagesSearchResults.items.push({
        id:
          resObj.message_type == "sent"
            ? resObj?.to_user?.using_employee_id
            : resObj?.from_user?.using_employee_id == 0
            ? ""
            : resObj?.from_user?.using_employee_id,
        user_id:
          resObj.message_type == "sent"
            ? resObj?.to_user?.using_employee_id
            : resObj?.from_user?.using_employee_id == 0
            ? ""
            : resObj?.from_user?.using_employee_id,
        name:
          resObj.message_type == "sent"
            ? resObj.to_user.user_name
            : resObj.from_user.user_id == 0
            ? "－"
            : resObj.from_user.user_name,
        date: resObj.created_at,
        content: resObj.message,
        unread_count: resObj?.unread_count,
        url: `${SITE_MAP.THANKS_POINT_MESSAGES}?search=${search}&id=${resObj?.thanks_giving_id}`,
        icon: {
          original: "",
          large: "",
          medium:
            resObj.message_type == "sent"
              ? resObj.to_user.user_image
              : resObj.from_user.user_id == 0
              ? ""
              : resObj.from_user.user_image,
          small: ""
        },
        point: {
          total: resObj.points,
          pointAddition: false,
          state: resObj.message_type
        },
        unread: resObj.has_read === false ? true : false
      });
    });

    this.messagesSearchResults.total_count = thanksPointList?.count || 0;
  }

  async handleUserSearch(searchByUser: any, search: string) {
    searchByUser?.results?.forEach((resObj: any) => {
      this.usersSearchResults.items.push({
        id: resObj?.user?.using_employee_id,
        user_id: resObj?.user?.using_employee_id,
        name: resObj?.user?.user_name,
        content: "",
        unread_count: resObj?.user?.count_has_read,
        url: `${SITE_MAP.THANKS_POINT_USER_SPECIFIC}?search=&id=${resObj.user.id}`,
        icon: {
          original: "",
          large: "",
          medium: resObj?.user?.user_image,
          small: ""
        },
        point: {
          point_addition: false,
          state: "send"
        },
        unread: resObj?.user?.count_has_read != 0 ? true : false,
        unreadCount: resObj?.thanks_giving_count
      });
    });

    this.usersSearchResults.total_count = searchByUser?.count || 0;
  }

  handlePager() {
    let prevPage = this.currentPage - 1;

    if (prevPage == 0) {
      prevPage = 1;
    }
    const nextPage = this.currentPage + 1;
    const count = this.thankPointSearchList?.count ?? 1;
    const maxPage =
      count % this.pageSize >= 1
        ? Math.floor(count / this.pageSize) + 1
        : count / this.pageSize;

    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;
    this.pageNavi.baseUrl = `${SITE_MAP.THANKS_POINT}?`;
    this.searchKeyword = this.searchKeyword === "" ? " " : this.searchKeyword;
    this.pageNavi.nextPageUrl =
      this.pageNavi.baseUrl + `page=${nextPage}&search=${this.searchKeyword}`;
    this.pageNavi.prevPageUrl =
      this.pageNavi.baseUrl + `page=${prevPage}&search=${this.searchKeyword}`;
  }
}
